import { Point } from "pixi.js";
import { MapZonesViewDescription } from "../types/MapZonesViewDescription";
import { MapZipCodeDescription } from "../types/MapZipCodeDescription";
import { MarketplaceResourcePackage } from "../../resources/MarketplaceResourcePackage";

export class MapViewConfig {
    public static createMapZonesViewDescription(marketplaceResources: MarketplaceResourcePackage): Array<MapZonesViewDescription> {
        const mapZonesViewDescription = new Array<MapZonesViewDescription>(
            {
                area: 1,
                position: new Point(2, 426),
                mapZoneDescription: {
                    mapZoneBg: marketplaceResources.assets_views_marketplace_map_f_1_png,
                    mapZoneBgPosition: new Point(14.9, 551.8),
                    cornerTexture: marketplaceResources.assets_views_marketplace_zip_zone_1_png,
                    cornerPosition: new Point(0, -3),
                    selectedTexture: marketplaceResources.assets_views_marketplace_zone_1_white_line_png,
                    selectedGlowPosition: new Point(-2, -66),
                    otherPinPosition: new Point(189, 785),
                    myPinPosition: new Point(252, 810)
                },
                mapZoneZipCodesDescription: new Array<MapZipCodeDescription>(
                    {
                        zipCode: "10002",
                        zipCodePosition: new Point(165, 145),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_corners_10002_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_selectedglow_10002_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(496, 410),
                        myPinPosition: new Point(620, 420)
                    },
                    {
                        zipCode: "10012",
                        zipCodePosition: new Point(141, 103),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_corners_10012_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_selectedglow_10012_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(435, 270),
                        myPinPosition: new Point(430, 321)
                    },
                    {
                        zipCode: "10005",
                        zipCodePosition: new Point(67, 208),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_corners_10005_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_selectedglow_10005_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(241, 480),
                        myPinPosition: new Point(201, 500)
                    },
                    {
                        zipCode: "10038",
                        zipCodePosition: new Point(89, 198),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_corners_10038_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_selectedglow_10038_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(344, 442),
                        myPinPosition: new Point(301, 465)
                    },
                    {
                        zipCode: "10007",
                        zipCodePosition: new Point(72, 164),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_corners_10007_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_selectedglow_10007_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(205, 370),
                        myPinPosition: new Point(258, 393)
                    },
                    {
                        zipCode: "10004",
                        zipCodePosition: new Point(22, 218),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_corners_10004_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_selectedglow_10004_png,
                        selectedGlowPosition: new Point(-34, -80),
                        otherPinPosition: new Point(94, 522),
                        myPinPosition: new Point(151, 521)
                    },
                    {
                        zipCode: "10280",
                        zipCodePosition: new Point(14, 188),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_corners_10280_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_selectedglow_10280_png,
                        selectedGlowPosition: new Point(-22, -79),
                        otherPinPosition: new Point(80, 445),
                        myPinPosition: new Point(128, 430)
                    },
                    {
                        zipCode: "10282",
                        zipCodePosition: new Point(43, 161),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_corners_10282_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_selectedglow_10282_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(136, 360),
                        myPinPosition: new Point(154, 368)
                    },
                    {
                        zipCode: "10006",
                        zipCodePosition: new Point(59, 183),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_corners_10006_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_selectedglow_10006_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(196, 409),
                        myPinPosition: new Point(189, 425)
                    },
                    {
                        zipCode: "10013",
                        zipCodePosition: new Point(78, 92),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_corners_10013_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_selectedglow_10013_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(252, 279),
                        myPinPosition: new Point(316, 321)
                    },
                    {
                        zipCode: "10003",
                        zipCodePosition: new Point(205, 72),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_corners_10003_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_selectedglow_10003_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(577, 183),
                        myPinPosition: new Point(580, 250)
                    },
                    {
                        zipCode: "10009",
                        zipCodePosition: new Point(245, 99),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_corners_10009_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_selectedglow_10009_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(753, 272),
                        myPinPosition: new Point(700, 317)
                    },
                    {
                        zipCode: "10014",
                        zipCodePosition: new Point(112, 40),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_corners_10014_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_selectedglow_10014_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(327, 150),
                        myPinPosition: new Point(355, 206)
                    },
                    {
                        zipCode: "10011",
                        zipCodePosition: new Point(149, 12),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_corners_10011_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_1_selectedglow_10011_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(430, 83),
                        myPinPosition: new Point(483, 151)
                    }
                )
            },
            {
                position: new Point(147, 297),
                area: 2,
                mapZoneDescription: {
                    mapZoneBg: marketplaceResources.assets_views_marketplace_map_f_2_png,
                    mapZoneBgPosition: new Point(158.9, 404.8),
                    cornerTexture: marketplaceResources.assets_views_marketplace_zip_zone_2_png,
                    cornerPosition: new Point(0, 0),
                    selectedTexture: marketplaceResources.assets_views_marketplace_zone_2_white_line_png,
                    selectedGlowPosition: new Point(-67, -67),
                    otherPinPosition: new Point(320, 629),
                    myPinPosition: new Point(347, 681)
                },
                mapZoneZipCodesDescription: new Array<MapZipCodeDescription>(
                    {
                        zipCode: "10017",
                        zipCodePosition: new Point(173, 125),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_corners_10017_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_selectedglow_10017_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(520, 300),
                        myPinPosition: new Point(562, 353)
                    },
                    {
                        zipCode: "10023",
                        zipCodePosition: new Point(135, 14),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_corners_10023_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_selectedglow_10023_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(428, 80),
                        myPinPosition: new Point(506, 66)
                    },
                    {
                        zipCode: "10019",
                        zipCodePosition: new Point(98, 53),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_corners_10066_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_selectedglow_10066_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(330, 140),
                        myPinPosition: new Point(496, 204)
                    },
                    {
                        zipCode: "10020",
                        zipCodePosition: new Point(173, 106),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_corners_10020_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_selectedglow_10020_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(419, 220),
                        myPinPosition: new Point(442, 220)
                    },
                    {
                        zipCode: "10036",
                        zipCodePosition: new Point(74, 85),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_corners_10036_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_selectedglow_10036_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(300, 218),
                        myPinPosition: new Point(350, 245)
                    },
                    {
                        zipCode: "10018",
                        zipCodePosition: new Point(42, 95),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_corners_10018_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_selectedglow_10018_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(180, 213),
                        myPinPosition: new Point(243, 236)
                    },
                    {
                        zipCode: "10001",
                        zipCodePosition: new Point(17, 113),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_corners_10001_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_selectedglow_10001_png,
                        selectedGlowPosition: new Point(-19, -80),
                        otherPinPosition: new Point(166, 325),
                        myPinPosition: new Point(225, 352)
                    },
                    {
                        zipCode: "10065",
                        zipCodePosition: new Point(250, 83),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_corners_10065_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_selectedglow_10065_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(635, 178),
                        myPinPosition: new Point(738, 220)
                    },
                    {
                        zipCode: "10022",
                        zipCodePosition: new Point(212, 98),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_corners_10022_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_selectedglow_10022_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(618, 267),
                        myPinPosition: new Point(675, 280)
                    },
                    {
                        zipCode: "10016",
                        zipCodePosition: new Point(133, 154),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_corners_10016_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_selectedglow_10016_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(424, 385),
                        myPinPosition: new Point(485, 429)
                    },
                    {
                        zipCode: "10010",
                        zipCodePosition: new Point(111, 183),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_corners_10010_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_2_selectedglow_10010_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(323, 407),
                        myPinPosition: new Point(363, 441)
                    }
                )
            },
            {
                area: 3,
                position: new Point(317, 208),
                mapZoneDescription:
                {
                    mapZoneBg: marketplaceResources.assets_views_marketplace_map_f_3_png,
                    mapZoneBgPosition: new Point(322.1, 291.8),
                    cornerTexture: marketplaceResources.assets_views_marketplace_zip_zone_3_png,
                    cornerPosition: new Point(3, -1),
                    selectedTexture: marketplaceResources.assets_views_marketplace_zone_3_white_line_png,
                    selectedGlowPosition: new Point(-66, -66),
                    otherPinPosition: new Point(547, 535),
                    myPinPosition: new Point(505, 580)
                },
                mapZoneZipCodesDescription: new Array<MapZipCodeDescription>(
                    {
                        zipCode: "10024",
                        zipCodePosition: new Point(19, 67),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_corners_10024_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_selectedglow_10024_png,
                        selectedGlowPosition: new Point(-39, -80),
                        otherPinPosition: new Point(126, 196),
                        myPinPosition: new Point(219, 205)
                    },
                    {
                        zipCode: "10021",
                        zipCodePosition: new Point(101, 150),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_corners_10021_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_selectedglow_10021_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(313, 366),
                        myPinPosition: new Point(407, 407)
                    },
                    {
                        zipCode: "10044",
                        zipCodePosition: new Point(133, 166),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_corners_10044_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_selectedglow_10044_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(534, 400),
                        myPinPosition: new Point(420, 470)
                    },
                    {
                        zipCode: "10000",
                        zipCodePosition: new Point(35, 47),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_corners_10000_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_selectedglow_10000_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(350, 200),
                        myPinPosition: new Point(262, 277)
                    },
                    {
                        zipCode: "10028",
                        zipCodePosition: new Point(144, 123),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_corners_10028_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_selectedglow_10028_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(407, 280),
                        myPinPosition: new Point(458, 309)
                    },
                    {
                        zipCode: "10128",
                        zipCodePosition: new Point(169, 101),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_corners_10128_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_selectedglow_10128_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(486, 241),
                        myPinPosition: new Point(548, 282)
                    },
                    {
                        zipCode: "10075",
                        zipCodePosition: new Point(132, 140),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_corners_10075_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_selectedglow_10075_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(440, 338),
                        myPinPosition: new Point(503, 364)
                    },
                    {
                        zipCode: "10029",
                        zipCodePosition: new Point(198, 60),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_corners_10029_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_selectedglow_10029_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(579, 184),
                        myPinPosition: new Point(643, 202)
                    },
                    {
                        zipCode: "10026",
                        zipCodePosition: new Point(176, 24),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_corners_10026_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_selectedglow_10026_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(494, 61),
                        myPinPosition: new Point(556, 83)
                    },
                    {
                        zipCode: "10025",
                        zipCodePosition: new Point(72, 15),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_corners_10025_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_3_selectedglow_10025_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(272, 100),
                        myPinPosition: new Point(343, 125)
                    }
                )
            },
            {
                area: 4,
                position: new Point(446, 0),
                mapZoneDescription:
                {
                    mapZoneBg: marketplaceResources.assets_views_marketplace_map_f_4_png,
                    mapZoneBgPosition: new Point(461.8, 162.2),
                    cornerTexture: marketplaceResources.assets_views_marketplace_zip_zone_4_png,
                    cornerPosition: new Point(1, -1),
                    selectedTexture: marketplaceResources.assets_views_marketplace_zone_4_white_line_png,
                    selectedGlowPosition: new Point(-66, -66),
                    otherPinPosition: new Point(631, 353),
                    myPinPosition: new Point(610, 436)
                },
                mapZoneZipCodesDescription: new Array<MapZipCodeDescription>(
                    {
                        zipCode: "10027",
                        zipCodePosition: new Point(16, 188),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_corners_10027_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_selectedglow_10027_png,
                        selectedGlowPosition: new Point(-11, -80),
                        otherPinPosition: new Point(132, 471),
                        myPinPosition: new Point(278, 498)
                    },
                    {
                        zipCode: "10034",
                        zipCodePosition: new Point(207, 13),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_corners_10034_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_selectedglow_10034_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(661, 72),
                        myPinPosition: new Point(768, 59)
                    },
                    {
                        zipCode: "10040",
                        zipCodePosition: new Point(165, 54),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_corners_10040_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_selectedglow_10040_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(528, 154),
                        myPinPosition: new Point(615, 120)
                    },
                    {
                        zipCode: "10033",
                        zipCodePosition: new Point(144, 76),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_corners_10033_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_selectedglow_10033_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(465, 206),
                        myPinPosition: new Point(520, 229)
                    },
                    {
                        zipCode: "10032",
                        zipCodePosition: new Point(81, 116),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_corners_10032_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_selectedglow_10032_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(334, 282),
                        myPinPosition: new Point(400, 299)
                    },
                    {
                        zipCode: "10039",
                        zipCodePosition: new Point(163, 142),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_corners_10039_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_selectedglow_10039_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(444, 349),
                        myPinPosition: new Point(477, 387)
                    },
                    {
                        zipCode: "10031",
                        zipCodePosition: new Point(68, 156),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_corners_10031_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_selectedglow_10031_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(210, 383),
                        myPinPosition: new Point(270, 405)
                    },
                    {
                        zipCode: "10030",
                        zipCodePosition: new Point(132, 184),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_corners_10030_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_selectedglow_10030_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(344, 441),
                        myPinPosition: new Point(389, 435)
                    },
                    {
                        zipCode: "10037",
                        zipCodePosition: new Point(156, 196),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_corners_10037_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_selectedglow_10037_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(421, 471),
                        myPinPosition: new Point(466, 495)
                    },
                    {
                        zipCode: "10035",
                        zipCodePosition: new Point(124, 234),
                        cornerTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_corners_10035_png,
                        selectedTexture: marketplaceResources.assets_views_marketplace_zip_zones_4_selectedglow_10035_png,
                        selectedGlowPosition: new Point(-80, -80),
                        otherPinPosition: new Point(545, 667),
                        myPinPosition: new Point(423, 593)
                    }
                )
            }
        );
        return mapZonesViewDescription;
    }
}
